import '../styles/GlobalDesign.css';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : process.env.REACT_APP_API_URL || '/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/password-reset/request`, { email });
      
      if (response.data.success) {
        setSuccess(true);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de l\'envoi de l\'email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      {/* Navbar */}
      <nav className="new-design-navbar" style={{ position: 'fixed', top: 0 }}>
        <div className="new-design-container">
          <Link to="/" className="new-design-logo">
            <img src="/logo.png" alt="Fluxivo" className="new-design-logo-img" style={{height: '36px', width: 'auto'}} />
            <span className="new-design-logo-text">Flux<span>ivo</span></span>
          </Link>
          <Link to="/reseller/login" className="new-design-btn-login">Connexion</Link>
        </div>
      </nav>

      <div className="auth-page-container" style={{ maxWidth: '500px' }}>
        <div className="auth-page-header">
          <h1 className="auth-page-title">
            🔑 Mot de passe oublié
          </h1>
          <p className="auth-page-subtitle">Entrez votre email pour recevoir un lien de réinitialisation</p>
        </div>

        {success ? (
          <div className="auth-success-section">
            <div className="auth-success-icon">✅</div>
            <h2 className="auth-success-title">Email envoyé !</h2>
            <p className="auth-success-text">
              Si un compte existe avec l'email <strong className="text-green">{email}</strong>, 
              vous recevrez un lien de réinitialisation dans quelques instants.
            </p>
            <div className="notice-box" style={{ marginBottom: '1rem' }}>
              <p style={{ marginBottom: '0.5rem' }}>
                ⏰ Le lien expire dans 1 heure
              </p>
              <p style={{ margin: 0 }}>
                📧 Vérifiez aussi vos spams si vous ne recevez pas l'email
              </p>
            </div>
            <Link to="/reseller/login" className="new-design-btn new-design-btn-primary" style={{ width: '100%', marginTop: '1rem' }}>
              ← Retour à la connexion
            </Link>
          </div>
        ) : (
          <>
            {error && <div className="auth-error-message">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="new-design-form-group">
                <label>Adresse email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="votre@email.com"
                  disabled={loading}
                />
              </div>

              <button type="submit" className="new-design-btn new-design-btn-primary" style={{ width: '100%' }} disabled={loading}>
                {loading ? 'Envoi en cours...' : 'Envoyer le lien de réinitialisation'}
              </button>
            </form>

            <div className="auth-center-link">
              <Link to="/reseller/login">
                ← Retour à la connexion
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
